require('../styles.css');
"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/icons/monochrome/IconPrintOrder.tsx
var IconPrintOrder_exports = {};
__export(IconPrintOrder_exports, {
  default: () => IconPrintOrder_default
});
module.exports = __toCommonJS(IconPrintOrder_exports);

// src/assets/monochrome/printOrder.svg
var import_jsx_runtime = require("react/jsx-runtime");
var SvgPrintOrder = (props) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2.34702 1.50623C1.08747 1.50623 0.0664062 2.52729 0.0664062 3.78684V14.5011C0.0664062 15.4789 0.859045 16.2715 1.83681 16.2715H2.52879C2.60654 17.602 3.71013 18.657 5.06013 18.657C6.41012 18.657 7.51372 17.602 7.59147 16.2715H12.4087C12.4864 17.602 13.59 18.657 14.94 18.657C16.29 18.657 17.3936 17.602 17.4713 16.2715H18.1636C19.1413 16.2715 19.934 15.4789 19.934 14.5011V11.0735C19.934 10.4918 19.7522 9.92466 19.4141 9.45133L17.5485 6.8394C17.2161 6.37415 16.6796 6.09802 16.1078 6.09802H13.8113V3.78684C13.8113 2.52729 12.7902 1.50623 11.5307 1.50623H2.34702ZM17.087 14.7715H18.1636C18.3129 14.7715 18.434 14.6504 18.434 14.5011V11.1693L13.8115 11.1693V13.8499C14.1514 13.6807 14.5346 13.5856 14.94 13.5856C15.8443 13.5856 16.6381 14.059 17.087 14.7715ZM17.7265 9.66931L13.8115 9.66931V7.59802H16.1078C16.1952 7.59802 16.2771 7.6402 16.3279 7.71126L17.7265 9.66931ZM7.20715 14.7715H12.3113V3.78684C12.3113 3.35572 11.9618 3.00623 11.5307 3.00623H2.34702C1.9159 3.00623 1.56641 3.35572 1.56641 3.78684V14.5011C1.56641 14.6505 1.68747 14.7715 1.83681 14.7715H2.91311C3.36199 14.059 4.15577 13.5856 5.06013 13.5856C5.96448 13.5856 6.75826 14.059 7.20715 14.7715ZM4.02441 16.1213C4.02441 15.5493 4.48812 15.0856 5.06013 15.0856C5.63214 15.0856 6.09584 15.5493 6.09584 16.1213C6.09584 16.6933 5.63214 17.157 5.06013 17.157C4.48812 17.157 4.02441 16.6933 4.02441 16.1213ZM13.9043 16.1213C13.9043 15.5493 14.368 15.0856 14.94 15.0856C15.512 15.0856 15.9757 15.5493 15.9757 16.1213C15.9757 16.6933 15.512 17.157 14.94 17.157C14.368 17.157 13.9043 16.6933 13.9043 16.1213Z", fill: "#676F7E" }) });
var printOrder_default = SvgPrintOrder;

// src/Wrappers/helpers.ts
var getIconBaseCssVariables = ({
  size,
  rotate,
  transitionDuration
}) => {
  return {
    "--icon-size": size ? `${size}px` : "100%",
    "--icon-rotate": rotate ? `${rotate}deg` : "0deg",
    // Browser cannot handle multiple transitions on the same property if another variable (e.g. --transition-duration)
    // is defined on another element.
    "--icon-transition-fill": transitionDuration ? `fill ${transitionDuration} ease` : "none",
    "--icon-transition-transform": transitionDuration ? `transform ${transitionDuration} ease` : "none"
  };
};
var getIconColoringCssVariables = ({
  state,
  color,
  activeColor
}) => {
  return {
    "--icon-color": state === "active" ? activeColor : color,
    "--icon-active-color": state === "disabled" || !activeColor ? color : activeColor
  };
};

// src/Wrappers/IconWrapper.tsx
var import_jsx_runtime2 = require("react/jsx-runtime");
var getWrapperStyles = (props) => ({
  ...getIconBaseCssVariables(props),
  ...getIconColoringCssVariables(props)
});
var IconWrapper = (props) => {
  return /* @__PURE__ */ (0, import_jsx_runtime2.jsx)(
    "div",
    {
      className: "ui-icon-size-wrapper ui-icon-coloring-wrapper",
      style: getWrapperStyles(props),
      children: props.children
    }
  );
};

// src/icons/monochrome/IconPrintOrder.tsx
var import_jsx_runtime3 = require("react/jsx-runtime");
var IconPrintOrder = (props) => {
  return /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(IconWrapper, { ...props, children: /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(printOrder_default, {}) });
};
IconPrintOrder.displayName = "IconPrintOrder";
var IconPrintOrder_default = IconPrintOrder;
